module.exports = __webpack_public_path__ + "img/saldo.821c59b2.png";